var TRANSLATIONS_LS_CACHE_KEYS = {
  CURRENT_LOCALE: 'currentLocale',
  // current locale being displayed, which user explicitly selects from language selector etc.
  PREFERRED_LOCALE: 'preferredLocale',
  // the locale which logged in user prefers
  SUPPORTED_LOCALE: 'supportedLocale' // list of locale that is supported by the user dealership

};
export default TRANSLATIONS_LS_CACHE_KEYS;